import * as React from 'react'

import { Box, Icon, Text } from '@factorialco/deprecated-design-system'
import { MarketplaceInstallationFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import Table from 'modules/payroll_integrations/components/Table'
import type { Codeable, ColumnNames } from 'modules/payroll_integrations/lib/types'

interface ArchivedSectionProps {
  columnNames: ColumnNames
  codeables: Record<string, Codeable>
  integration: string
  integrationInstallation?: MarketplaceInstallationFragment
}

const ArchivedSection: React.FC<ArchivedSectionProps> = ({
  columnNames,
  codeables,
  integration,
  integrationInstallation,
}) => {
  const [open, setOpen] = React.useState(false)

  return (
    <>
      <Box paddingY="s32" flexDirection="row" gap="s12">
        <Text.Normal weight="medium">
          {i18n.t('payroll_integrations.settings.disabled_section_title')}
        </Text.Normal>
        <Box onClick={() => setOpen(!open)} paddingTop="s4">
          <Icon.Small icon={open ? 'chevron-up' : 'chevron-down'} color="grey600" />
        </Box>
      </Box>
      {open && (
        <Table
          columnNames={columnNames}
          codeables={codeables}
          integration={integration}
          integrationInstallation={integrationInstallation}
        />
      )}
    </>
  )
}

export default ArchivedSection
